import { DOMHelper } from "../Helpers/DOMHelper.js";

export class Modal {
    constructor(app, classAtt, content, openBtnSelector, additionalClasses) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = classAtt;
        this.content = content;
        this.openBtnSelector = openBtnSelector;
        this.additionalClasses = additionalClasses || "";
        this.hideCallback = null;
        this.showCallback = null;
        this.isMouseDownOnModal = false;
    }

    addHtml() {
        // <span class="drs-close-modal-btn">x</span>
        let html =
            `<div class="pm-drs-modal ` +
            this.classAtt +
            " " +
            this.additionalClasses +
            `">
			<!-- <div class="drs-modal-background"></div> --!>
			<div class="drs-modal-content">				
                <span class="drs-close-modal-btn">&times;</span>
				` +
            this.content +
            `
			</div>
		</div>
		`;
        let pmDrsModalsSelector = "." + this.app.wrapperClassId + ".pmdrs-modals";
        document.querySelector(pmDrsModalsSelector).insertAdjacentHTML("beforeend", html);
    }

    init() {
        this.addHtml();
        this.addHandlers();
    }

    addHandlers() {
        let thisModal = this;

        DOMHelper.addHandler(this.getSelector(".drs-modal-background"), "click", () => {
            thisModal.hide();
        });

        DOMHelper.addHandler(this.getSelector(".drs-close-modal-btn"), "click", () => {
            document.querySelector("body").style.setProperty("position", "inherit", "important");
            thisModal.hide();
        });

        DOMHelper.addHandler(this.app.getSelector(this.openBtnSelector), "click", () => {
            thisModal.show();
        });

        DOMHelper.addHandler(thisModal.getModalElement(), "mousedown", (event) => {
            const modalEl = thisModal.getModalElement();
            const scrollbarWidth = modalEl.offsetWidth - modalEl.clientWidth;
            
            // Check if the click is on the scrollbar
            const isScrollbarClick = event.offsetX >= modalEl.clientWidth && scrollbarWidth > 0;
            
            if (!isScrollbarClick) {
                thisModal.isMouseDownOnModal = event.target === modalEl;
            }            
        });

        DOMHelper.addHandler(thisModal.getModalElement(), "mouseup", (event) => {
            if (thisModal.isMouseDownOnModal && event.target == thisModal.getModalElement()) {
                thisModal.hide();
            }
        });
    }

    getModalElement() {
        return document.querySelector(this.app.getSelector("." + this.classAtt + ".pm-drs-modal"));
    }

    show() {
        document.querySelector("body").style.overflowY = "hidden";
        this.getModalElement().classList.add("show");
         if (this.showCallback) {
            this.showCallback();
        }
    }

    setShowCallback(callback) {
        this.showCallback = callback;
    }

    hide() {
        document.querySelector("body").style.overflowY = "auto";
        this.getModalElement().classList.remove("show");
        if (this.hideCallback) {
            this.hideCallback();
        }
    }

    setHideCallback(callback) {
        this.hideCallback = callback;
    }

    getSelector(selector) {
        return ".pmdrs-modals ." + this.classAtt + " " + selector;
    }
}
